import { Injectable } from '@angular/core';

import { BaseService } from './base.service';

@Injectable()
export class QuestionUnconformityResponseService {

	path = '/question-unconformity-response';

	constructor(private baseService: BaseService) { }

	getUnconformities(query) {
		return this.baseService.postWithParams(this.path, '/getAll', query);
	}
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/service/question-unconformity-response.service.ts